import React, { useEffect } from "react";
import { Box, Typography, Container, Grid, Button, Link } from "@mui/material";
import { motion } from "framer-motion";
import heroBg from "../../assets/nextix/business-cloud-banner.jpg";
import cityWideWhitepaper from '../../City-wide-whitepaper.pdf';
import globalVideoWhitepaper from '../../Global-Video-whitepaper.pdf';
import ipPhonesWhitepaper from '../../IP-Phones.pdf';
import ofwContactCenterWhitepaper from '../../OFW-Contact-Center.pdf';

const CloudScreen = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box sx={{ backgroundColor: "#fff" }}>
            {/* BANNER IMAGE - Full image display in container */}
            <Container maxWidth="lg" sx={{ pt: 12, pb: 4 }}>
                <Box sx={{
                    borderRadius: "8px",
                    overflow: "hidden"
                }}>
                    <img
                        src={heroBg}
                        alt="Cloud - Managed Services and Solutions"
                        style={{
                            width: "100%",
                            height: "auto",
                            display: "block"
                        }}
                    />
                </Box>
            </Container>

            {/* MAIN CONTENT */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Grid container spacing={{ xs: 2, md: 6 }}>
                    {/* Left Column - Main Content */}
                    <Grid item xs={12} md={8}>
                        {/* Main Cloud Section */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Cloud
                            </Typography>
                            {/* 
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                (Introductory text if any, seeing none in original file, leaving placeholder or removing)
                            </Typography> 
                            */}
                        </motion.div>

                        {/* Hospital Information System */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.1 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Hospital Information System
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Hospital Information System (HIS) provides a common source of information about a patient’s health history. It is a comprehensive integrated system designed to manage all the aspects of a hospital’s operation such as medical, administrative, financial, legal issues and the corresponding processing of services.
                            </Typography>
                        </motion.div>

                        {/* e-Forms */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                e-Forms
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Dynamic creator of online electronic forms designed to capture, validate, and submit data for processing.
                            </Typography>
                        </motion.div>

                        {/* e-Procurement */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                e-Procurement
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Nextix e-Procurement is a full suite platform that supports procurement processes, document management, PKI, authentication and verification. e-Procurement can be used for government and enterprise procurement automation.
                            </Typography>
                        </motion.div>

                        {/* Cybersecurity */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Cybersecurity
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Protect your digital presence with Nextix end-to-end cybersecurity services. Nextix provides your company tools to secure and monitor websites, online applications and other internet enabled services.
                            </Typography>
                        </motion.div>

                        {/* Data Archiving */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.5 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Data Archiving
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Nextix provides a wide-range of options for your archiving needs. Storage size, retention and access frequency can vary according to your preference.
                            </Typography>
                        </motion.div>

                        {/* Digital Document Authentication */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.6 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Digital Document Authentication
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Nextix caters a fully integrated platform for digital document authentication. Secure your document management system with integration to blockchain, permanent storage, and artificial intelligence. The platform is API ready so you can integrate your existing systems easily.
                            </Typography>
                        </motion.div>

                        {/* Chatbot – Artificial Intelligence */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.7 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Chatbot – Artificial Intelligence
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, textAlign: "start" }}>
                                Enhance your customer experience using an advanced chatbot platform supported by artificial intelligence. No need to develop your own chatbot, Nextix makes it easy for you.
                            </Typography>
                        </motion.div>
                    </Grid>

                    {/* Right Column - Sidebar */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ position: { md: "sticky" }, top: 100, textAlign: 'start' }}>
                            {/* Send Us A Message */}
                            <motion.div
                                initial={{ opacity: 0, x: 30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6 }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: "#375ca8" }}>
                                    Send Us A Message
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 3, color: "#666", lineHeight: 1.6 }}>
                                    For more inquiries about our Products, send us a message
                                </Typography>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    href="mailto:info@nextix.co"
                                    sx={{
                                        backgroundColor: "#82c9ed",
                                        color: "white",
                                        fontWeight: 700,
                                        py: 1.5,
                                        mb: 4,
                                        "&:hover": { backgroundColor: "#6bb5d9" }
                                    }}
                                >
                                    CONTACT OUR SALES NOW
                                </Button>
                            </motion.div>

                            {/* Contact Information */}
                            <motion.div
                                initial={{ opacity: 0, x: 30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.1 }}
                            >
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: "#1c1c1c" }}>
                                    Email Us:
                                </Typography>

                                <Box sx={{ mb: 2 }}>
                                    <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                                        <strong>Inquiry:</strong>{" "}
                                        <Link href="mailto:info@nextix.co" sx={{ color: "#375ca8", textDecoration: "none" }}>
                                            info@nextix.co
                                        </Link>
                                    </Typography>
                                </Box>

                                <Box sx={{ mb: 2 }}>
                                    <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                                        <strong>Support:</strong>{" "}
                                        <Link href="mailto:helpdesk@nextix.co" sx={{ color: "#375ca8", textDecoration: "none" }}>
                                            helpdesk@nextix.co
                                        </Link>
                                    </Typography>
                                </Box>

                                <Box sx={{ mb: 4 }}>
                                    <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                                        <strong>Privacy:</strong>{" "}
                                        <Link href="mailto:dpo@nextix.co" sx={{ color: "#375ca8", textDecoration: "none" }}>
                                            dpo@nextix.co
                                        </Link>
                                    </Typography>
                                </Box>

                                {/* White Paper Resources */}
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: "#1c1c1c" }}>
                                    White Paper
                                </Typography>

                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                    <Link href={ofwContactCenterWhitepaper} target="_blank" rel="noopener noreferrer" sx={{ color: "#375ca8", textDecoration: "none", fontSize: "0.875rem", "&:hover": { textDecoration: "none", color: '#5bc0de' } }}>
                                        OFW-Contact-Center
                                    </Link>
                                    <Link href={globalVideoWhitepaper} target="_blank" rel="noopener noreferrer" sx={{ color: "#375ca8", textDecoration: "none", fontSize: "0.875rem", "&:hover": { textDecoration: "none", color: '#5bc0de' } }}>
                                        Global-Video-whitepaper
                                    </Link>
                                    <Link href={cityWideWhitepaper} target="_blank" rel="noopener noreferrer" sx={{ color: "#375ca8", textDecoration: "none", fontSize: "0.875rem", "&:hover": { textDecoration: "none", color: '#5bc0de' } }}>
                                        City-wide-whitepaper
                                    </Link>
                                    {/* <Link href={ipPhonesWhitepaper} target="_blank" rel="noopener noreferrer" sx={{ color: "#375ca8", textDecoration: "none", fontSize: "0.875rem", "&:hover": { textDecoration: "none", color: '#5bc0de' } }}>
                                        IP-Phones
                                    </Link> */}
                                </Box>
                            </motion.div>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default CloudScreen;
